import {Component, forwardRef, Input} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SyncValidatorComponent} from '../utils/base.component';
import {Person} from '../app/types';
import {config} from '../app/config';
import {GruppenBuchung} from "./buchung";

@Component({
  selector: 'app-teilnehmer',
  templateUrl: './teilnehmer.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TeilnehmerComponent)
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => TeilnehmerComponent)
    }
  ]
})
export class TeilnehmerComponent extends SyncValidatorComponent {
  geburtsdatumMin = config.geburtsdatumMin;
  geburtsdatumInit = config.geburtsdatumInit;
  geburtsdatumMax = config.geburtsdatumMax;
  formGroup: FormGroup;

  @Input() buchung: GruppenBuchung;

  constructor(private fb: FormBuilder) {
    super();
    this.formGroup = this.fb.group({
      participants: this.fb.array([])
    });
    this.formGroup.valueChanges.subscribe(value => {
      this.triggerValidation();
      this.form2buchung();
    });
  }

  validate(c: FormControl) {
    const err = {
      requiredError: {
        r: 'required!'
      }
    };
    return this.formGroup.valid ? null : err;
  }

  set(participants: Person[]) {
    const formGroups = participants.map(p => this.createFormGroup(p));
    const formArray = this.fb.array(formGroups);
    this.formGroup.setControl('participants', formArray);
  }

  get participants(): FormArray {
    return this.formGroup.get('participants') as FormArray;
  }

  add() {
    const person = this.buchung.createWeiterePerson();
    this.buchung.addWeiterePerson(person);
    this.participants.push(this.createFormGroup(person));
  }
  removeAt(i: number) {
    const person = this.participants.value[i];
    this.participants.removeAt(i);
    this.buchung.removeWeiterePerson(person);
  }

  private createFormGroup(participant: Person): FormGroup {
    const formGroup = this.fb.group(participant);
    formGroup.markAsPending();
    return formGroup;
  }

  private form2buchung() {
    if (!this.formGroup.valid) {
      return;
    }
    this.participants.value.forEach(person => this.buchung.addWeiterePerson(person));
  }
}
